import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { useIntl, FormattedMessage } from 'react-intl';

import * as S from './styles';
import Sparkle from '../ui/Sparkle';
import { Cta } from '../ui/PriceList';
import { PHONE } from '../../consts/index';

export function useWhatsappLink() {
  const intl = useIntl();
  const text = intl.formatMessage({ id: 'splash.whatsappText' });
  return `https://wa.me/${PHONE}?text=${encodeURIComponent(text)}`;
}

function Splash() {
  const intl = useIntl();
  const whatsapp = useWhatsappLink();

  return (
    <>
      <S.Container>
        <S.Content>
          <S.Eyebrow>
            <Sparkle size={12} />
            <FormattedMessage id="hero.eyebrow" />
          </S.Eyebrow>

          <S.Wordmark>
            Spedine
            <span>Studio</span>
          </S.Wordmark>

          <S.Tagline>
            <FormattedMessage id="hero.tagline" />
          </S.Tagline>

          <S.Actions>
            <Cta href={whatsapp} target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faWhatsapp} />
              <FormattedMessage id="hero.book" />
            </Cta>
            <Cta className="ghost" href="#precos">
              <FormattedMessage id="hero.seePrices" />
            </Cta>
          </S.Actions>
        </S.Content>

        <S.ScrollCue href="#politica" aria-label={intl.formatMessage({ id: 'hero.scroll' })}>
          <FormattedMessage id="hero.scroll" />
        </S.ScrollCue>
      </S.Container>

      <S.Float
        href={whatsapp}
        target="_blank"
        rel="noreferrer"
        aria-label={intl.formatMessage({ id: 'hero.book' })}
      >
        <FontAwesomeIcon icon={faWhatsapp} />
        <span>
          <FormattedMessage id="nav.book" />
        </span>
      </S.Float>
    </>
  );
}

export default Splash;
